export * from './Eye';
export * from './Social';
export * from './Ticket';
export * from './LocationPin';
export * from './Facebook';
export * from './Twitter';
export * from './Instagram';
export * from './Mail';

export * from './Accord';
export * from './Tirelire';
export * from './Graphique';



// WEBPACK FOOTER //
// src/app/src/components/Icons/index.ts